import React from "react";
import { Box, Button, Paper } from "@mui/material";
import { BookOpen, Home, List, RefreshCcw } from "lucide-react";

export default function ResultadosBottomActions({
  onReviewQuestions,
  onViewExplanations,
  onRetrySimulator,
  onGoDashboard,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        border: "1px solid #dbeafe",
        borderRadius: "14px",
        p: { xs: 1.25, sm: 1.5 },
        backgroundColor: "#ffffff",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gap: 1.25,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            lg: "repeat(4, minmax(0, 1fr))",
          },
        }}
      >
        <Button
          variant="contained"
          onClick={onReviewQuestions}
          startIcon={<List size={18} />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            py: 1.1,
            bgcolor: "#2563eb",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#1d4ed8",
              boxShadow: "none",
            },
          }}
        >
          Revisar preguntas
        </Button>

        <Button
          variant="outlined"
          onClick={onViewExplanations}
          startIcon={<BookOpen size={18} />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            py: 1.1,
            borderColor: "#93c5fd",
            color: "#2563eb",
            "&:hover": {
              borderColor: "#60a5fa",
              backgroundColor: "#eff6ff",
            },
          }}
        >
          Ver explicaciones
        </Button>

        <Button
          variant="outlined"
          onClick={onRetrySimulator}
          startIcon={<RefreshCcw size={18} />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            py: 1.1,
            borderColor: "#93c5fd",
            color: "#2563eb",
            "&:hover": {
              borderColor: "#60a5fa",
              backgroundColor: "#eff6ff",
            },
          }}
        >
          Repetir simulador
        </Button>

        <Button
          variant="outlined"
          onClick={onGoDashboard}
          startIcon={<Home size={18} />}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            py: 1.1,
            borderColor: "#93c5fd",
            color: "#2563eb",
            "&:hover": {
              borderColor: "#60a5fa",
              backgroundColor: "#eff6ff",
            },
          }}
        >
          Volver al dashboard
        </Button>
      </Box>
    </Paper>
  );
}
